<div class="page-layout carded fullwidth inner-scroll">
  <div class="center">
    <div class="header" fxLayout="row" fxLayoutAlign="space-between center">
      <span class="h1"> {{ 'RECURRENCES.TITLE' | translate }} </span>

      <div class="page-buttons" fxHide.xs>
        <button
          mat-stroked-button
          [matTooltip]="'RECURRENCES.CREATE_RECURRENCE' | translate"
          [disabled]="!hasCreateRecurrencePermission"
          (click)="openDialog()"
        >
          <i
            matTooltipPosition="left"
            class="angularjs-fuse-icon icon-plus"
            [matTooltip]="'RECURRENCES.PERMISSIONS.NO_CREATE' | translate"
            [matTooltipDisabled]="hasCreateRecurrencePermission"
          ></i>
        </button>

        <button
          *ngIf="hasCreateExportPermission"
          mat-stroked-button
          [matTooltip]="'RECURRENCES.EXPORT_EXCEL' | translate"
          (click)="openExportDialog()"
          [disabled]="!totalCount"
        >
          <i class="angularjs-fuse-icon icon-file-excel"></i>
        </button>

        <button
          *ngIf="filtered"
          mat-stroked-button
          [matTooltip]="'RECURRENCES.FILTER_CLEAR' | translate"
          (click)="clearFilters()"
        >
          <i class="angularjs-fuse-icon icon-filter-remove"></i>
        </button>

        <button
          mat-stroked-button
          [matTooltip]="'RECURRENCES.FILTER.TITLE' | translate"
          (click)="sidenavService.open('filterRecurrences')"
        >
          <i class="angularjs-fuse-icon icon-filter"></i>
        </button>

        <button mat-stroked-button [matTooltip]="'RECURRENCES.RELOAD' | translate" (click)="reload()">
          <i class="angularjs-fuse-icon icon-reload small"></i>
        </button>
      </div>

      <div class="page-buttons" fxShow="false" fxShow.xs>
        <button mat-stroked-button [matMenuTriggerFor]="menuRecurrences">
          <mat-icon class="accent-500-fg">keyboard_arrow_down</mat-icon>
        </button>

        <mat-menu #menuRecurrences>
          <button
            [disabled]="!hasCreateRecurrencePermission"
            mat-menu-item
            fxLayout="row"
            fxLayoutAlign="start center"
            (click)="openDialog()"
          >
            <i class="angularjs-fuse-icon icon-plus mr-4"></i>
            <span [translate]="'RECURRENCES.CREATE_RECURRENCE'">Add</span>
          </button>

          <button
            *ngIf="hasCreateExportPermission"
            mat-menu-item
            fxLayout="row"
            fxLayoutAlign="start center"
            (click)="openExportDialog()"
            [disabled]="!totalCount"
          >
            <i class="angularjs-fuse-icon icon-file-excel"></i>
            <span>{{ 'RECURRENCES.EXPORT_EXCEL' | translate }}</span>
          </button>

          <button *ngIf="filtered" mat-menu-item fxLayout="row" fxLayoutAlign="start center" (click)="clearFilters()">
            <i class="angularjs-fuse-icon icon-filter-remove mr-4"></i>
            <span [translate]="'RECURRENCES.FILTER_CLEAR'">Clear filter</span>
          </button>

          <button
            mat-menu-item
            fxLayout="row"
            fxLayoutAlign="start center"
            (click)="sidenavService.open('filterRecurrences')"
          >
            <i class="angularjs-fuse-icon icon-filter mr-4"></i>
            <span [translate]="'RECURRENCES.FILTER.TITLE'">Filter</span>
          </button>

          <button mat-menu-item fxLayout="row" fxLayoutAlign="start center" (click)="reload()">
            <i class="angularjs-fuse-icon icon-reload small mr-4"></i>
            <span [translate]="'RECURRENCES.RELOAD'">Reload</span>
          </button>
        </mat-menu>
      </div>
    </div>

    <div class="content-card datatable">
      <mat-table
        #datatable
        class="datatable__table"
        [dataSource]="recurrences"
        fusePerfectScrollbar
        matSort
        [matSortDisableClear]="true"
      >
        <ng-container matColumnDef="location">
          <mat-header-cell *matHeaderCellDef fxFlex="20" mat-sort-header>
            {{ 'RECURRENCES.HEADER.LOCATION' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let recurrence" fxFlex="20" fxFlex.xs="100">
            <span class="mobile-label">{{ 'RECURRENCES.HEADER.LOCATION' | translate }}:</span>
            <div
              class="label-color"
              [ngClass]="{ 'red-500-bg': recurrence.archived, 'green-500-bg': !recurrence.archived }"
            ></div>
            <span class="limit-cells" [matTooltip]="recurrence.location?.name" [matTooltipShowDelay]="500">
              {{ recurrence.location?.name }}
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="company">
          <mat-header-cell *matHeaderCellDef fxFlex="18">
            {{ 'RECURRENCES.HEADER.COMPANY' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let recurrence" fxFlex="18" fxFlex.xs="100">
            <span class="mobile-label">{{ 'RECURRENCES.HEADER.COMPANY' | translate }}:</span>
            <span
              class="limit-cells"
              [matTooltipShowDelay]="500"
              [matTooltip]="recurrence.company?.name"
              [matTooltipDisabled]="!recurrence.company?.name"
            >
              {{ recurrence.company?.name || '-' }}
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="segment">
          <mat-header-cell *matHeaderCellDef fxFlex="15" mat-sort-header>
            {{ 'RECURRENCES.HEADER.SEGMENT' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let recurrence" fxFlex="15" fxFlex.xs="100">
            <span class="mobile-label">{{ 'RECURRENCES.HEADER.SEGMENT' | translate }}:</span>
            <span class="limit-cells" [matTooltipShowDelay]="500" [matTooltip]="recurrence.segment?.name">
              {{ recurrence.segment?.name }}
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="maintenanceType">
          <mat-header-cell *matHeaderCellDef fxFlex="20" mat-sort-header fxHide.xs>
            {{ 'RECURRENCES.HEADER.TYPE' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let recurrence" fxFlex="20" fxHide.xs>
            <span class="limit-cells" [matTooltipShowDelay]="500" [matTooltip]="recurrence.maintenanceType?.name">
              {{ recurrence.maintenanceType?.name }}
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="message">
          <mat-header-cell *matHeaderCellDef fxFlex="100" fxHide.xs>
            {{ 'RECURRENCES.HEADER.MESSAGE' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let recurrence" fxFlex="100" fxHide.xs>
            <span
              class="limit-cells"
              [matTooltipShowDelay]="500"
              [matTooltip]="recurrence.message"
              [matTooltipDisabled]="!recurrence.message"
            >
              {{ recurrence.message || '-' }}
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="createdAt">
          <mat-header-cell *matHeaderCellDef fxFlex="10" mat-sort-header fxHide.xs>
            {{ 'RECURRENCES.HEADER.CREATED_AT' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let recurrence" fxFlex="10" fxHide.xs>
            <span
              class="limit-cells"
              [matTooltipShowDelay]="500"
              [matTooltip]="recurrence.createdAt | date: 'dd/MM/yyyy HH:mm'"
            >
              {{ recurrence.createdAt | date: 'dd/MM/yyyy HH:mm' }}
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="edit">
          <mat-header-cell *matHeaderCellDef fxFlex="7">
            {{ 'RECURRENCES.HEADER.ACTIONS' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let recurrence" fxFlex="7">
            <span class="mobile-label uppercase">{{ 'RECURRENCES.EDIT' | translate }}</span>
            <button
              mat-icon-button
              [matTooltip]="(hasEditRecurrencePermission ? 'RECURRENCES.EDIT' : 'RECURRENCES.VIEW') | translate"
              (click)="openDialog(recurrence.id)"
            >
              <img src="assets/images/icons/new_icon_edit_action.svg" alt="edit recurrence" />
            </button>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="noData">
          <mat-footer-cell
            *matFooterCellDef
            [attr.colspan]="displayedColumns.length"
            fxLayout="column"
            fxLayoutAlign="center center"
          >
            {{ 'RECURRENCES.NO_DATA' | translate }}
          </mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="loading">
          <mat-footer-cell
            *matFooterCellDef
            [attr.colspan]="displayedColumns.length"
            fxLayout="column"
            fxLayoutAlign="center center"
          >
            <div class="p-24" fxLayout="column" fxLayoutAlign="center center">
              <mat-spinner color="primary" diameter="64" class="mb-24"></mat-spinner>
              {{ 'RECURRENCES.LOADING' | translate }}
            </div>
          </mat-footer-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns" [class.display-none]="loading"></mat-row>
        <mat-footer-row *matFooterRowDef="['noData']" [hidden]="loading || recurrences?.length"></mat-footer-row>
        <mat-footer-row *matFooterRowDef="['loading']" [hidden]="!loading"></mat-footer-row>
      </mat-table>
      <mat-paginator [length]="totalCount" [pageSizeOptions]="[25, 50, 100, 200, 250]"></mat-paginator>
    </div>
  </div>
</div>

<fuse-sidebar name="filterRecurrences" key="filterRecurrences" position="right" lockedOpen="true">
  <filter-recurrences class="sidebar-filter"></filter-recurrences>
</fuse-sidebar>
